import { Module } from "vuex";
import { IRootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IServiceAccount } from "@/models/serviceaccount";

export interface IServiceAccountsState {
    SAScopedList: IServiceAccount[] | null;
    SAUnscopedList: IServiceAccount[] | null;
    selectedServiceAccount: IServiceAccount | null;
    isSelectedServiceAccount: boolean;
    scopedSAError: any;
    unscopedSAError: any;
}

export const getDefaultSAState = (): IServiceAccountsState => {
    return {
        SAScopedList: [],
        SAUnscopedList: [],
        selectedServiceAccount: null,
        isSelectedServiceAccount: false,
        scopedSAError: null,
        unscopedSAError: null,
    };
};

const state = getDefaultSAState();

const namespaced: boolean = true;

export const serviceAccounts: Module<IServiceAccountsState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
